import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
});

export const LanguageProvider = ({ children }) => {
  const getInitialLang = () => {
    try {
      // 1) If a logged user exists with preferredLanguage, use it
      const userRaw = localStorage.getItem("user");
      if (userRaw) {
        const user = JSON.parse(userRaw);
        if (
          user &&
          typeof user.preferredLanguage === "string" &&
          user.preferredLanguage.trim()
        ) {
          return user.preferredLanguage;
        }
      }

      // 2) Fallback to stored app language (new key appLang or old key lang)
      const stored =
        localStorage.getItem("appLang") || localStorage.getItem("lang");
      if (stored) return stored;

      // 3) First time visitor → use browser language if available
      if (typeof navigator !== "undefined") {
        const navLangs =
          (navigator.languages && navigator.languages.length
            ? navigator.languages
            : [navigator.language]
          ) || [];
        const first = (navLangs[0] || "").toString();
        if (first) {
          const code = first.split(/[-_]/)[0].toLowerCase();
          if (code) return code;  // e.g. "en" from "en-US"
        }
      }

      // 4) Final fallback
      return "en";
    } catch {
      return "en";
    }
  };

  const [lang, setLang] = useState(getInitialLang);

  // Persist language changes
  useEffect(() => {
    try {
      localStorage.setItem("appLang", lang);
      // also keep old key for backwards compatibility
      localStorage.setItem("lang", lang);
    } catch {
      // ignore storage errors
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
